"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9],{

/***/ 9677:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

// Placeholder for a footer to replace the old `react-web-app` footer
var Footer = function() {
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 4271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4033);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1506);



var PartnerHeader = function(param) {
    var logo = param.logo, name = param.name, logoHeight = param.logoHeight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        maxW: "7xl",
        mx: "auto",
        p: 8,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .HStack */ .Ug, {
            align: "center",
            spacing: 10,
            divider: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .StackDivider */ .cX, {}),
            children: [
                logo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .Ee, {
                        src: logo,
                        alt: name,
                        height: logoHeight || "36px",
                        objectFit: "contain"
                    })
                }) : undefined,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .Ee, {
                    src: "/static/images/logo.png",
                    alt: "",
                    height: "36px",
                    objectFit: "contain"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PartnerHeader);


/***/ }),

/***/ 3340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7328);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4033);





var PageContainer = function(_param) /*#__PURE__*/ {
    var children = _param.children, _maxW = _param.maxW, maxW = _maxW === void 0 ? "7xl" : _maxW, _minH = _param.minH, minH = _minH === void 0 ? "100vh" : _minH, _p = _param.p, p = _p === void 0 ? 8 : _p, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "maxW",
        "minH",
        "p"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        maxW: maxW,
        minH: minH,
        p: p
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PageContainer);


/***/ }),

/***/ 7754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ internal_IntakeViewModel; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(4033);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/spinner/dist/chakra-ui-spinner.esm.js
var chakra_ui_spinner_esm = __webpack_require__(9204);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/alert/dist/chakra-ui-alert.esm.js
var chakra_ui_alert_esm = __webpack_require__(1135);
// EXTERNAL MODULE: ../../node_modules/analytics/lib/analytics.browser.es.js + 8 modules
var analytics_browser_es = __webpack_require__(8249);
// EXTERNAL MODULE: ../../node_modules/@analytics/google-analytics/lib/analytics-plugin-ga.browser.es.js
var analytics_plugin_ga_browser_es = __webpack_require__(1289);
;// CONCATENATED MODULE: ./services/analytics/analytics.ts

// @ts-ignore

var analytics = null;
var initialize = function() {
    if (!analytics) {
        try {
            analytics = (0,analytics_browser_es/* default */.ZP)({
                app: "intake-form",
                debug: true,
                version: 100,
                plugins: [
                    (0,analytics_plugin_ga_browser_es/* default */.Z)({
                        measurementIds: [
                            "G-EWY1MG4RH3"
                        ]
                    }), 
                ]
            });
        } catch (e) {
            console.error(e);
        }
    }
    return analytics;
};
/* harmony default export */ var analytics_analytics = (initialize);

;// CONCATENATED MODULE: ./services/analytics/hooks.ts


var useTrack = function(eventName, payload) {
    return (0,react.useEffect)(function() {
        var ref;
        (ref = analytics_analytics()) === null || ref === void 0 ? void 0 : ref.track(eventName, payload);
    }, []);
};
var usePage = function(pageData) {
    return (0,react.useEffect)(function() {
        var ref;
        (ref = analytics_analytics()) === null || ref === void 0 ? void 0 : ref.page(pageData);
    }, []);
};

;// CONCATENATED MODULE: ./services/analytics/events.ts
var INTAKE_VIEWED = "Intake Viewed";
var INTAKE_PAYMENT_STARTED = "Intake Payment Started";
var INTAKE_PAYMENT_COMPLETE = "Intake Payment Complete";
var INTAKE_ACCOUNT_LINKING_STARTED = "Intake Account Linking Started";
var INTAKE_COMPLETE = "Intake Complete";

;// CONCATENATED MODULE: ./containers/Intake/validateConfig.ts
var validateConfig = function(config) {
    if (config.reps && !config.reps.every(function(r) {
        return r.franchiseCode;
    })) throw new Error("Missing required rep.franchiseCode");
};
/* harmony default export */ var Intake_validateConfig = (validateConfig);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var src_object_spread = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/react-final-form/dist/react-final-form.es.js + 3 modules
var react_final_form_es = __webpack_require__(3178);
;// CONCATENATED MODULE: ./components/form/setFieldTouched.js
/* from https://github.com/final-form/final-form-set-field-touched
 * tsc didn't like the yarn version
 */ 
var setFieldTouched = function(args, state) {
    var _args = (0,_sliced_to_array/* default */.Z)(args, 2), name = _args[0], touched = _args[1];
    var field = state.fields[name];
    if (field) {
        field.touched = !!touched;
    }
};
/* harmony default export */ var form_setFieldTouched = (setFieldTouched);

;// CONCATENATED MODULE: ./hooks/usePage.ts

var usePage_usePage = function(initialPage, maxPage) {
    var ref = (0,react.useState)(initialPage), page = ref[0], setPage = ref[1];
    var increment = function() {
        return setPage(function(p) {
            return p < maxPage ? p + 1 : maxPage;
        });
    };
    var decrement = function() {
        return setPage(function(p) {
            return p > 0 ? p - 1 : 0;
        });
    };
    var jump = function(p) {
        return setPage(p);
    };
    return [
        page,
        increment,
        decrement,
        jump
    ];
};
/* harmony default export */ var hooks_usePage = (usePage_usePage);

;// CONCATENATED MODULE: ./services/getAddonList.ts
var getAddonList = function(config, formValues) {
    var ref;
    var result = [];
    var planConfig = (ref = config.plan) === null || ref === void 0 ? void 0 : ref.countries[formValues.address.country].periods.find(function(p) {
        return p.id === formValues.plan;
    });
    planConfig === null || planConfig === void 0 ? void 0 : planConfig.addons.forEach(function(addon) {
        var ref;
        var value = (ref = formValues.addons) === null || ref === void 0 ? void 0 : ref[addon.id];
        if (!value) return;
        switch(addon.type){
            case "multiselect":
                value.forEach(function(v) {
                    var option = addon.options.find(function(o) {
                        return o.id === v;
                    });
                    if (!option) return;
                    result.push({
                        addon: addon,
                        option: option,
                        id: option.itemPriceId || option.id,
                        label: option.label,
                        price: option.price,
                        unit: option.unit
                    });
                });
                break;
            default:
                break;
        }
    });
    return result;
};
/* harmony default export */ var services_getAddonList = (getAddonList);

;// CONCATENATED MODULE: ./containers/Intake/normalizeFormState.ts


var normalizeFormState = function(state, config) {
    return (0,src_object_spread/* default */.Z)({}, state, normalizePlans(state, config), normalizePlan(state, config));
};
// This is the newer version for handling a single plan with multiple versions and addons
var normalizePlan = function(state, config) {
    if (!config.plan) return {};
    var planCountry = config.plan.countries[state.address.country];
    if (!planCountry) return {};
    var planPeriod = planCountry.periods.find(function(p) {
        return p.id === state.plan;
    });
    if (!planPeriod) return {};
    return {
        plan: planPeriod.id,
        addons: services_getAddonList(config, state)
    };
};
var normalizePlans = function(state, config) {
    if (!config.plans) return {};
    var planConfig = config.plans.find(function(p) {
        return p.value === state.plan;
    });
    var plan = (planConfig === null || planConfig === void 0 ? void 0 : planConfig.values) ? planConfig.values[state.address.country] : state.plan;
    return {
        plan: plan
    };
};
/* harmony default export */ var Intake_normalizeFormState = (normalizeFormState);

;// CONCATENATED MODULE: ./containers/Intake/state.ts



var UPDATE = "update_field";
var UPDATE_ADDRESS = "update_address";
var UPDATE_CONTACT = "update_contact";
var UPDATE_PARTNER = "update_partner";
var UPDATE_QUESTION = "update_question";
var ERRORS = "errors";
var initialState = {
    errors: {},
    form: {
        partner: {
            code: "",
            repEmail: "",
            franchiseCode: ""
        },
        id: "",
        name: "",
        description: "",
        phone: "",
        url: "",
        facebookPage: "",
        instagramProfile: "",
        info: "",
        token: "",
        address: {
            streetNumber: "",
            streetName: "",
            unit: "",
            city: "",
            stateCode: "",
            postalCode: "",
            country: ""
        },
        pricePlan: "",
        contact: {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            onboardingPreference: "email"
        },
        questions: {},
        plan: ""
    }
};
var capitalize = function(string) {
    return "".concat(string.charAt(0).toUpperCase()).concat(string.substr(1, string.length));
};
var reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    var _payload = action.payload, name = _payload.name, value = _payload.value;
    switch(action.type){
        case UPDATE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    errors: _object_spread_props(_object_spread({}, state.errors), _define_property({}, name, false)),
                    form: _object_spread_props(_object_spread({}, state.form), _define_property({}, name, value))
                });
            }
        case UPDATE_ADDRESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    errors: _object_spread_props(_object_spread({}, state.errors), _define_property({}, name, false)),
                    form: _object_spread_props(_object_spread({}, state.form), {
                        address: _object_spread_props(_object_spread({}, state.form.address), _define_property({
                            // Reset stateCode when we change country because 🙃
                            stateCode: name === "country" ? "" : state.form.address.stateCode
                        }, name, value))
                    })
                });
            }
        case UPDATE_CONTACT:
            {
                var errorField = "contact".concat(capitalize(name));
                return _object_spread_props(_object_spread({}, state), {
                    errors: _object_spread_props(_object_spread({}, state.errors), _define_property({}, errorField, false)),
                    form: _object_spread_props(_object_spread({}, state.form), {
                        contact: _object_spread_props(_object_spread({}, state.form.contact), _define_property({}, name, value))
                    })
                });
            }
        case UPDATE_PARTNER:
            {
                var errorField1 = "partner".concat(capitalize(name));
                return _object_spread_props(_object_spread({}, state), {
                    errors: _object_spread_props(_object_spread({}, state.errors), _define_property({}, errorField1, false)),
                    form: _object_spread_props(_object_spread({}, state.form), {
                        partner: _object_spread_props(_object_spread({}, state.form.partner), _define_property({}, name, value))
                    })
                });
            }
        case UPDATE_QUESTION:
            {
                var errorField2 = "question".concat(capitalize(name));
                return _object_spread_props(_object_spread({}, state), {
                    errors: _object_spread_props(_object_spread({}, state.errors), _define_property({}, errorField2, false)),
                    form: _object_spread_props(_object_spread({}, state.form), {
                        questions: _object_spread_props(_object_spread({}, state.form.questions), _define_property({}, name, _object_spread_props(_object_spread({}, state.form.questions[name]), {
                            response: value
                        })))
                    })
                });
            }
        case ERRORS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    errors: action.payload
                });
            }
        default:
            {
                return state;
            }
    }
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js
var chakra_ui_form_control_esm = __webpack_require__(2840);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/textarea/dist/chakra-ui-textarea.esm.js
var chakra_ui_textarea_esm = __webpack_require__(6652);
;// CONCATENATED MODULE: ./components/Intake/Label.tsx






var Label = function(_param) {
    var optional = _param.optional, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "optional",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
            justify: "space-between",
            align: "center",
            w: "100%",
            children: [
                children,
                optional && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    fontSize: "sm",
                    color: "gray.500",
                    children: "Optional"
                })
            ]
        })
    }));
};
/* harmony default export */ var Intake_Label = (Label);

;// CONCATENATED MODULE: ./containers/Intake/form/TextAreaField.tsx








var TextAreaField = function(_param) {
    var name = _param.name, label = _param.label, validate = _param.validate, optional = _param.optional, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "validate",
        "optional"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        name: name,
        validate: validate,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_Label, {
                        optional: optional,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_textarea_esm/* Textarea */.g, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, input, rest), {
                        isInvalid: meta.touched && meta.error,
                        errorBorderColor: "red.300"
                    })),
                    meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "red.300",
                        fontSize: "sm",
                        mt: 2,
                        px: 4,
                        children: meta.error
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var form_TextAreaField = (TextAreaField);

;// CONCATENATED MODULE: ./containers/Intake/form/validators.ts
var required = function(error) {
    return function(value) {
        return value ? undefined : error;
    };
};
var emailRegex = /(.+)@(.+){2,}\.(.+){2,}/;
var email = function(error) {
    return function(value) {
        if (!value) return ""; // compose with required if desired
        if (emailRegex.test(value)) return "";
        return error;
    };
};
var phoneRegex = /^\D*\d{3}\D*\d{3}\D*\d{4}\D*$/;
var DEFAULT_PHONE_ERROR = "Please enter complete phone number ((999) 999-9999)";
var phone = function(error) {
    return function(value) {
        if (!value) return ""; // compose with required if desired
        if (phoneRegex.test(value)) return "";
        return error || DEFAULT_PHONE_ERROR;
    };
};
var regex = function(regex, error) {
    return function(value) {
        if (!value) return ""; // compose with required if desired
        if (regex.test(value)) return "";
        return error;
    };
};
var compose = function() {
    for(var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++){
        validators[_key] = arguments[_key];
    }
    return function(value) {
        var result;
        validators.every(function(fn) {
            if (!fn) return null;
            result = fn(value);
            return !result;
        });
        return result;
    };
};


;// CONCATENATED MODULE: ./containers/Intake/BusinessDetailsView.tsx





var BusinessDetailsView = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                    fontSize: "2xl",
                    mb: 6,
                    children: "Business Details"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* VStack */.gC, {
                spacing: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_TextAreaField, {
                    name: "description",
                    placeholder: "Provide a high level description of the business and what they do",
                    validate: required("Please enter a description of your business."),
                    h: "7lh"
                })
            })
        ]
    });
};
/* harmony default export */ var Intake_BusinessDetailsView = (BusinessDetailsView);

// EXTERNAL MODULE: ../../node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(1974);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(6106);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(9680);
;// CONCATENATED MODULE: ./containers/Intake/form/BackButton.tsx





var BackButton = function(props) {
    var isSmallScreen = (0,chakra_ui_media_query_esm/* useBreakpointValue */.Sx)({
        base: true,
        sm: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, (0,src_object_spread/* default */.Z)({
        mt: 10,
        mb: 3,
        w: isSmallScreen ? "100%" : "min-content",
        size: "sm",
        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ArrowBackIcon */.Rp, {})
    }, props));
};
/* harmony default export */ var form_BackButton = (BackButton);

;// CONCATENATED MODULE: ./containers/Intake/form/MainButton.tsx




var MainButton = function(props) {
    var isSmallScreen = (0,chakra_ui_media_query_esm/* useBreakpointValue */.Sx)({
        base: true,
        sm: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, (0,src_object_spread/* default */.Z)({
        mt: 10,
        mb: 3,
        w: isSmallScreen ? "100%" : "min-content",
        colorScheme: "blue"
    }, props));
};
/* harmony default export */ var form_MainButton = (MainButton);

// EXTERNAL MODULE: ../../node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(38);
;// CONCATENATED MODULE: ./containers/Intake/form/InputField.tsx








var InputField = function(_param) {
    var name = _param.name, label = _param.label, validate = _param.validate, optional = _param.optional, placeholder = _param.placeholder, maxLength = _param.maxLength, flex = _param.flex, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "validate",
        "optional",
        "placeholder",
        "maxLength",
        "flex"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        name: name,
        validate: validate,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                flex: flex,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_Label, {
                        optional: optional,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, input, rest), {
                        placeholder: placeholder,
                        maxLength: maxLength,
                        isInvalid: meta.touched && meta.error,
                        errorBorderColor: "red.300"
                    })),
                    meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "red.300",
                        fontSize: "sm",
                        mt: 2,
                        px: 4,
                        children: meta.error
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var form_InputField = (InputField);

// EXTERNAL MODULE: ../../node_modules/@chakra-ui/select/dist/chakra-ui-select.esm.js
var chakra_ui_select_esm = __webpack_require__(28);
;// CONCATENATED MODULE: ./containers/Intake/form/SelectField.tsx








var SelectField = function(_param) {
    var name = _param.name, label = _param.label, validate = _param.validate, optional = _param.optional, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "validate",
        "optional",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        name: name,
        validate: validate,
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_Label, {
                        optional: optional,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_select_esm/* Select */.Ph, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, input, rest), {
                        isInvalid: meta.touched && meta.error,
                        errorBorderColor: "red.300",
                        children: children
                    })),
                    meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "red.300",
                        fontSize: "sm",
                        mt: 2,
                        px: 4,
                        children: meta.error
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var form_SelectField = (SelectField);

;// CONCATENATED MODULE: ./containers/Intake/QuestionsView.tsx








var Question = function(param) {
    var questionKey = param.questionKey, question = param.question;
    if (question.type === "select") {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_SelectField, {
                label: question.label,
                name: "questions.".concat(questionKey, ".response"),
                validate: question.required ? required("Required") : undefined,
                children: (ref = question.options) === null || ref === void 0 ? void 0 : ref.map(function(op) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: op.value,
                        children: op.label
                    }, op.value);
                })
            })
        });
    }
    if (question.type) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
            label: question.label,
            name: "questions.".concat(questionKey, ".response"),
            validate: question.required ? required("Required") : undefined,
            type: question.type,
            placeholder: question.placeholder,
            maxLength: 512,
            maxW: question.type === "color" ? "250px" : "unset"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(form_TextAreaField, {
        label: question.label,
        name: "questions.".concat(questionKey, ".response"),
        validate: question.required ? required("Required") : undefined,
        placeholder: question.placeholder,
        maxLength: 2048,
        h: "7lh"
    });
};
var QuestionsView = function(param) {
    var config = param.config;
    var questions = config.questions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                    fontSize: "2xl",
                    mb: 6,
                    children: "Product / Service Details"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                spacing: 5,
                align: "stretch",
                children: [
                    Object.entries(questions).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), questionKey = _param[0], question = _param[1];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                            w: "100%",
                            gap: {
                                base: "0.5em",
                                lg: "2em"
                            },
                            wrap: {
                                base: "wrap",
                                lg: "nowrap"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                                width: {
                                    base: "100%",
                                    lg: "66%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Question, {
                                    questionKey: questionKey,
                                    question: question
                                }, questionKey)
                            })
                        });
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        width: {
                            base: "100%",
                            lg: "66%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_SelectField, {
                            name: "contact.onboardingPreference",
                            label: "Onboarding Preference",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "email",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "video",
                                    children: "Video Call"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Intake_QuestionsView = (QuestionsView);

;// CONCATENATED MODULE: ./containers/Intake/internal/BusinessDetailsSection.tsx







var BusinessDetailsSection = function(param) {
    var config = param.config, onBack = param.onBack;
    // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
        gap: "1em",
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
            direction: "column",
            spacing: 8,
            w: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_BackButton, {
                    onClick: onBack,
                    children: "Back"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                    width: {
                        base: "100%",
                        lg: "66%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_BusinessDetailsView, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_QuestionsView, {
                    config: config
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_MainButton, {
                    type: "submit",
                    children: "Go to billing"
                })
            ]
        })
    });
};
/* harmony default export */ var internal_BusinessDetailsSection = (BusinessDetailsSection);

// EXTERNAL MODULE: ../../node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(5405);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(2970);
// EXTERNAL MODULE: ../../node_modules/chakra-react-select/dist/esm/async-select.js + 120 modules
var async_select = __webpack_require__(8617);
;// CONCATENATED MODULE: ./services/googlePlaces.ts




var API_KEY = "AIzaSyB1K5tMemCIZ_E0UMp5f6p947zJ5UwYg78";
var isInterpolated = function(prediction) {
    return prediction.placeId.length > 40;
};
var autoComplete = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, result, json, predictions;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query;
                    if (!query) return [
                        2,
                        []
                    ];
                    return [
                        4,
                        fetch("https://places.googleapis.com/v1/places:autocomplete", {
                            method: "POST",
                            // @ts-ignore
                            headers: {
                                "Content-Type": "application/json",
                                "X-Goog-Api-Key": API_KEY,
                                // 'x-Goog-FieldMask': '*',
                                "x-Goog-FieldMask": [
                                    "suggestions.placePrediction.placeId",
                                    "suggestions.placePrediction.text"
                                ].join(",")
                            },
                            body: JSON.stringify({
                                input: query,
                                includedRegionCodes: [
                                    "ca",
                                    "us"
                                ]
                            })
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        result.json()
                    ];
                case 2:
                    json = _state.sent();
                    predictions = json.suggestions.map(function(s) {
                        return s.placePrediction;
                    });
                    predictions.forEach(function(p) {
                        // eslint-disable-next-line no-param-reassign
                        p.isInterpolated = isInterpolated(p);
                    });
                    return [
                        2,
                        predictions || []
                    ];
            }
        });
    });
    return function autoComplete(_) {
        return _ref.apply(this, arguments);
    };
}();
var placeDetails = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var placeId, result, json, saneAddress;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placeId = param.placeId;
                    if (!placeId) return [
                        2,
                        null
                    ];
                    return [
                        4,
                        fetch("https://places.googleapis.com/v1/places/".concat(placeId), {
                            method: "GET",
                            // @ts-ignore
                            headers: {
                                "Content-Type": "application/json",
                                "X-Goog-Api-Key": API_KEY,
                                // 'x-Goog-FieldMask': '*',
                                "x-Goog-FieldMask": [
                                    "id",
                                    "addressComponents",
                                    "websiteUri"
                                ].join(",")
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        result.json()
                    ];
                case 2:
                    json = _state.sent();
                    if (!json) return [
                        2,
                        null
                    ];
                    saneAddress = getSaneAddress(json);
                    return [
                        2,
                        (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, json), {
                            saneAddress: saneAddress
                        })
                    ];
            }
        });
    });
    return function placeDetails(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSaneAddress = function(details) {
    var output = {
        streetNumber: "",
        streetName: "",
        unit: "",
        city: "",
        state: "",
        country: "",
        postalCode: ""
    };
    details.addressComponents.forEach(function(component) {
        if (component.types.includes("street_number")) {
            output.streetNumber = component.longText;
        } else if (component.types.includes("route")) {
            output.streetName = component.longText;
        } else if (component.types.includes("premise")) {
            output.unit = component.longText;
        } else if (component.types.includes("locality")) {
            output.city = component.longText;
        } else if (component.types.includes("administrative_area_level_1")) {
            output.state = component.shortText;
        } else if (component.types.includes("country")) {
            output.country = component.shortText;
        } else if (component.types.includes("postal_code")) {
            output.postalCode = component.longText;
        }
    });
    return output;
};


;// CONCATENATED MODULE: ./components/form/PlaceSearch.tsx






var MIN_CHARS = 3;
var PlaceSearch = function(param) {
    var onSelect = param.onSelect;
    var ref = (0,react.useState)([]), predictions = ref[0], setPredictions = ref[1];
    var onPredictionSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(placePrediction) {
            var details;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            placeDetails({
                                placeId: placePrediction.placeId
                            })
                        ];
                    case 1:
                        details = _state.sent();
                        onSelect(details);
                        return [
                            2
                        ];
                }
            });
        });
        return function onPredictionSelect(placePrediction) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(async_select/* default */.Z, {
        // @ts-ignore
        loadOptions: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(query) {
                var results;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if ((query === null || query === void 0 ? void 0 : query.length) < MIN_CHARS) return [
                                2,
                                null
                            ];
                            return [
                                4,
                                autoComplete({
                                    query: query
                                })
                            ];
                        case 1:
                            results = _state.sent();
                            // Store loaded options to work around ridiculous behaviour in react-select
                            setPredictions(results);
                            return [
                                2,
                                results
                            ];
                    }
                });
            });
            return function(query) {
                return _ref.apply(this, arguments);
            };
        }(),
        defaultOptions: predictions,
        cacheOptions: true,
        getOptionLabel: function(place) {
            return place.text.text;
        },
        getOptionValue: function(place) {
            return place.placeId;
        },
        // @ts-ignore
        onChange: onPredictionSelect,
        placeholder: "Enter a location",
        noOptionsMessage: function(param) {
            var inputValue = param.inputValue;
            if (!inputValue) return "Start typing...";
            return "No results found";
        }
    });
};
/* harmony default export */ var form_PlaceSearch = (PlaceSearch);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(930);
;// CONCATENATED MODULE: ./utils/regions.ts

var US_STATES = [
    {
        id: "AL",
        text: "Alabama",
        value: "Alabama"
    },
    {
        id: "AK",
        text: "Alaska",
        value: "Alaska"
    },
    {
        id: "AS",
        text: "American Samoa",
        value: "American Samoa"
    },
    {
        id: "AZ",
        text: "Arizona",
        value: "Arizona"
    },
    {
        id: "AR",
        text: "Arkansas",
        value: "Arkansas"
    },
    {
        id: "CA",
        text: "California",
        value: "California"
    },
    {
        id: "CO",
        text: "Colorado",
        value: "Colorado"
    },
    {
        id: "CT",
        text: "Connecticut",
        value: "Connecticut"
    },
    {
        id: "DE",
        text: "Delaware",
        value: "Delaware"
    },
    {
        id: "DC",
        text: "District Of Columbia",
        value: "District Of Columbia"
    },
    {
        id: "FM",
        text: "Federated States Of Micronesia",
        value: "Federated States Of Micronesia"
    },
    {
        id: "FL",
        text: "Florida",
        value: "Florida"
    },
    {
        id: "GA",
        text: "Georgia",
        value: "Georgia"
    },
    {
        id: "GU",
        text: "Guam",
        value: "Guam"
    },
    {
        id: "HI",
        text: "Hawaii",
        value: "Hawaii"
    },
    {
        id: "ID",
        text: "Idaho",
        value: "Idaho"
    },
    {
        id: "IL",
        text: "Illinois",
        value: "Illinois"
    },
    {
        id: "IN",
        text: "Indiana",
        value: "Indiana"
    },
    {
        id: "IA",
        text: "Iowa",
        value: "Iowa"
    },
    {
        id: "KS",
        text: "Kansas",
        value: "Kansas"
    },
    {
        id: "KY",
        text: "Kentucky",
        value: "Kentucky"
    },
    {
        id: "LA",
        text: "Louisiana",
        value: "Louisiana"
    },
    {
        id: "ME",
        text: "Maine",
        value: "Maine"
    },
    {
        id: "MH",
        text: "Marshall Islands",
        value: "Marshall Islands"
    },
    {
        id: "MD",
        text: "Maryland",
        value: "Maryland"
    },
    {
        id: "MA",
        text: "Massachusetts",
        value: "Massachusetts"
    },
    {
        id: "MI",
        text: "Michigan",
        value: "Michigan"
    },
    {
        id: "MN",
        text: "Minnesota",
        value: "Minnesota"
    },
    {
        id: "MS",
        text: "Mississippi",
        value: "Mississippi"
    },
    {
        id: "MO",
        text: "Missouri",
        value: "Missouri"
    },
    {
        id: "MT",
        text: "Montana",
        value: "Montana"
    },
    {
        id: "NE",
        text: "Nebraska",
        value: "Nebraska"
    },
    {
        id: "NV",
        text: "Nevada",
        value: "Nevada"
    },
    {
        id: "NH",
        text: "New Hampshire",
        value: "New Hampshire"
    },
    {
        id: "NJ",
        text: "New Jersey",
        value: "New Jersey"
    },
    {
        id: "NM",
        text: "New Mexico",
        value: "New Mexico"
    },
    {
        id: "NY",
        text: "New York",
        value: "New York"
    },
    {
        id: "NC",
        text: "North Carolina",
        value: "North Carolina"
    },
    {
        id: "ND",
        text: "North Dakota",
        value: "North Dakota"
    },
    {
        id: "MP",
        text: "Northern Mariana Islands",
        value: "Northern Mariana Islands"
    },
    {
        id: "OH",
        text: "Ohio",
        value: "Ohio"
    },
    {
        id: "OK",
        text: "Oklahoma",
        value: "Oklahoma"
    },
    {
        id: "OR",
        text: "Oregon",
        value: "Oregon"
    },
    {
        id: "PW",
        text: "Palau",
        value: "Palau"
    },
    {
        id: "PA",
        text: "Pennsylvania",
        value: "Pennsylvania"
    },
    {
        id: "PR",
        text: "Puerto Rico",
        value: "Puerto Rico"
    },
    {
        id: "RI",
        text: "Rhode Island",
        value: "Rhode Island"
    },
    {
        id: "SC",
        text: "South Carolina",
        value: "South Carolina"
    },
    {
        id: "SD",
        text: "South Dakota",
        value: "South Dakota"
    },
    {
        id: "TN",
        text: "Tennessee",
        value: "Tennessee"
    },
    {
        id: "TX",
        text: "Texas",
        value: "Texas"
    },
    {
        id: "UT",
        text: "Utah",
        value: "Utah"
    },
    {
        id: "VT",
        text: "Vermont",
        value: "Vermont"
    },
    {
        id: "VI",
        text: "Virgin Islands",
        value: "Virgin Islands"
    },
    {
        id: "VA",
        text: "Virginia",
        value: "Virginia"
    },
    {
        id: "WA",
        text: "Washington",
        value: "Washington"
    },
    {
        id: "WV",
        text: "West Virginia",
        value: "West Virginia"
    },
    {
        id: "WI",
        text: "Wisconsin",
        value: "Wisconsin"
    },
    {
        id: "WY",
        text: "Wyoming",
        value: "Wyoming"
    }, 
];
var PROVINCES = [
    {
        id: "AB",
        text: "Alberta",
        value: "Alberta"
    },
    {
        id: "BC",
        text: "British Columbia",
        value: "British Columbia"
    },
    {
        id: "MB",
        text: "Manitoba",
        value: "Manitoba"
    },
    {
        id: "NB",
        text: "New Brunswick",
        value: "New Brunswick"
    },
    {
        id: "NL",
        text: "Newfoundland and Labrador",
        value: "Newfoundland and Labrador"
    },
    {
        id: "NT",
        text: "Northwest Territories",
        value: "Northwest Territories"
    },
    {
        id: "NS",
        text: "Nova Scotia",
        value: "Nova Scotia"
    },
    {
        id: "NU",
        text: "Nunavut",
        value: "Nunavut"
    },
    {
        id: "ON",
        text: "Ontario",
        value: "Ontario"
    },
    {
        id: "PE",
        text: "Prince Edward Island",
        value: "Prince Edward Island"
    },
    {
        id: "QC",
        text: "Quebec",
        value: "Quebec"
    },
    {
        id: "SK",
        text: "Saskatchewan",
        value: "Saskatchewan"
    },
    {
        id: "YT",
        text: "Yukon",
        value: "Yukon"
    }, 
];
var COUNTRIES = [
    {
        id: 1,
        keyName: "CA",
        text: "Canada",
        value: "Canada",
        regionType: "province",
        codeType: "postalCode",
        codeLabel: "Postal Code",
        codeText: "A1A 1B1",
        mask: "a9a 9a9",
        regex: /^[a-z]\d[a-z]\s*\d[a-z]\d$/i,
        regions: (0,_to_consumable_array/* default */.Z)(PROVINCES)
    },
    {
        id: 2,
        keyName: "US",
        text: "United States",
        value: "United States",
        regionType: "state",
        codeType: "zipCode",
        codeLabel: "ZIP Code",
        codeText: "12345",
        mask: "99999-9999",
        regex: /^\d{5}(-\d{4})?$/,
        regions: (0,_to_consumable_array/* default */.Z)(US_STATES)
    }
];

;// CONCATENATED MODULE: ./containers/Intake/BusinessAddressView.tsx









var getCountryLabel = function(c) {
    var ref;
    return ((ref = COUNTRIES.find(function(item) {
        return item.keyName === c;
    })) === null || ref === void 0 ? void 0 : ref.text) || c;
};
var BusinessAddressView = function(param) {
    var config = param.config;
    var ref;
    var form = (0,react_final_form_es/* useForm */.cI)();
    var formState = (0,react_final_form_es/* useFormState */.cl)();
    var country = formState.values.address.country;
    var countryObject = COUNTRIES.find(function(item) {
        return item.keyName === country;
    }) || COUNTRIES[0];
    var lastCountry = (0,react.useRef)();
    (0,react.useEffect)(function() {
        // When country changes, reset state and postal code
        // But don't do it on mount
        if (lastCountry.current && lastCountry.current !== country) {
            form.batch(function() {
                form.change("address.stateCode", "");
                form.change("address.postalCode", "");
            });
        }
        lastCountry.current = country;
    }, [
        country
    ]);
    var updateFormStateFromSearch = function(value) {
        if (!value) return;
        form.batch(function() {
            form.change("address.streetNumber", value.saneAddress.streetNumber);
            form.change("address.streetName", value.saneAddress.streetName);
            form.change("address.unit", value.saneAddress.unit);
            form.change("address.city", value.saneAddress.city);
            form.change("address.country", value.saneAddress.country);
            if (value.websiteUri) {
                if (!formState.values.url) {
                    form.change("url", value.websiteUri);
                }
            }
        });
        // Done in two batches because changing the country resets the stateCode and postalCode
        form.batch(function() {
            form.change("address.stateCode", value.saneAddress.state);
            form.change("address.postalCode", value.saneAddress.postalCode);
        });
        // Mark all address fields as touched so form validation is visible immediately
        form.mutators.setFieldTouched("address.streetNumber", true);
        form.mutators.setFieldTouched("address.streetName", true);
        form.mutators.setFieldTouched("address.unit", true);
        form.mutators.setFieldTouched("address.city", true);
        form.mutators.setFieldTouched("address.country", true);
        form.mutators.setFieldTouched("address.stateCode", true);
        form.mutators.setFieldTouched("address.postalCode", true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                    fontSize: "2xl",
                    mb: 6,
                    children: "Business Address"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                spacing: 5,
                align: "stretch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_PlaceSearch, {
                        onSelect: updateFormStateFromSearch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                        direction: {
                            base: "column",
                            md: "row"
                        },
                        spacing: 5,
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                                label: "Street Number",
                                name: "address.streetNumber",
                                placeholder: "1234",
                                maxLength: 64,
                                validate: required("Required"),
                                flex: 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                                label: "Street Name",
                                name: "address.streetName",
                                placeholder: "Main St.",
                                maxLength: 128,
                                validate: required("Required"),
                                flex: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                                name: "address.unit",
                                label: "Unit",
                                optional: true,
                                placeholder: "100",
                                maxLength: 64,
                                flex: 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                        direction: {
                            base: "column",
                            md: "row"
                        },
                        spacing: 5,
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                                name: "address.city",
                                label: "City",
                                validate: required("Required"),
                                placeholder: "Kelowna",
                                maxLength: 128
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_SelectField, {
                                name: "address.stateCode",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.div */.m$.div, {
                                    textTransform: "capitalize",
                                    children: countryObject === null || countryObject === void 0 ? void 0 : countryObject.regionType
                                }),
                                validate: required("Required"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                        value: "",
                                        children: [
                                            "Select your ",
                                            countryObject === null || countryObject === void 0 ? void 0 : countryObject.regionType
                                        ]
                                    }),
                                    countryObject.regions.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: item.id,
                                            children: item.text
                                        }, item.id);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                        direction: {
                            base: "column",
                            md: "row"
                        },
                        spacing: 5,
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                                label: countryObject.codeLabel,
                                name: "address.postalCode",
                                placeholder: countryObject.codeText,
                                validate: compose(required("Required"), regex(countryObject.regex, "Invalid value (".concat(countryObject.mask, ")")))
                            }),
                            ((ref = config.countries) === null || ref === void 0 ? void 0 : ref.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(form_SelectField, {
                                label: "Country",
                                name: "address.country",
                                children: config.countries.map(function(c) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: c,
                                        children: getCountryLabel(c)
                                    }, c);
                                })
                            }) : false
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Intake_BusinessAddressView = (BusinessAddressView);

;// CONCATENATED MODULE: ./containers/Intake/BusinessContactView.tsx






var BusinessContactView = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                    fontSize: "2xl",
                    mb: 6,
                    children: "Business Contact"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                spacing: 5,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_Label, {
                                children: "Contact Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                gap: 5,
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                        flexGrow: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                                            name: "contact.firstName",
                                            maxLength: 128,
                                            placeholder: "John",
                                            validate: required("Required")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                        flexGrow: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                                            name: "contact.lastName",
                                            maxLength: 128,
                                            placeholder: "Smith"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                        name: "contact.email",
                        label: "Contact Email",
                        placeholder: "businesscontact@email.com",
                        maxLength: 70,
                        validate: compose(required("Required"), email("Please enter a valid email address."))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                        name: "contact.phone",
                        label: "Contact Phone Number",
                        placeholder: "604-555-1212",
                        validate: phone()
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Intake_BusinessContactView = (BusinessContactView);

;// CONCATENATED MODULE: ./containers/Intake/BusinessNameView.tsx




var BusinessNameView = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
        name: "name",
        label: "Business Name",
        placeholder: "The full name of your business",
        validate: required("Please enter your full business name.")
    });
};
/* harmony default export */ var Intake_BusinessNameView = (BusinessNameView);

;// CONCATENATED MODULE: ./containers/Intake/BusinessPresenceView.tsx




var BusinessPresenceView = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                    fontSize: "2xl",
                    mb: 6,
                    children: "Presence"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                spacing: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                        name: "url",
                        label: "Website URL",
                        optional: true,
                        placeholder: "https://mybusiness.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                        name: "facebookPage",
                        label: "Facebook Page",
                        optional: true,
                        placeholder: "facebook.com/yourpage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_InputField, {
                        name: "instagramProfile",
                        label: "Instagram Profile",
                        optional: true,
                        placeholder: "@yourprofile",
                        maxLength: 128
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Intake_BusinessPresenceView = (BusinessPresenceView);

;// CONCATENATED MODULE: ./containers/Intake/internal/BusinessMainSection.tsx








var BusinessMainSection = function(param) {
    var config = param.config;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
        direction: "column",
        spacing: 16,
        width: {
            base: "100%",
            lg: "66%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_BusinessNameView, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_BusinessAddressView, {
                config: config
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_BusinessContactView, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_BusinessPresenceView, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_MainButton, {
                type: "submit",
                children: "Select Plan Options"
            })
        ]
    });
};
/* harmony default export */ var internal_BusinessMainSection = (BusinessMainSection);

;// CONCATENATED MODULE: ./services/formatPrice.ts
var formatPrice = function(price) {
    // eslint-disable-next-line eqeqeq
    if (price == undefined) return undefined;
    return (price / 100).toLocaleString("en-US", {
        style: "currency",
        currency: "CAD",
        currencyDisplay: "narrowSymbol"
    });
};
/* harmony default export */ var services_formatPrice = (formatPrice);

;// CONCATENATED MODULE: ./containers/Intake/form/PriceLabel.tsx




var PriceLabel = function(param) {
    var price = param.price, unit = param.unit;
    if (!price && !unit) return null;
    var formattedPrice = services_formatPrice(price);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
        whiteSpace: "nowrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                children: formattedPrice
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.span */.m$.span, {
                color: "gray.500",
                children: unit
            })
        ]
    });
};
/* harmony default export */ var form_PriceLabel = (PriceLabel);

;// CONCATENATED MODULE: ./containers/Intake/RadioButton.tsx








var RadioButton = function(_param) {
    var iconPosition = _param.iconPosition, price = _param.price, unit = _param.unit, isActive = _param.isActive, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "iconPosition",
        "price",
        "unit",
        "isActive",
        "children"
    ]);
    var leftIcon;
    var rightIcon;
    var icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        opacity: isActive ? 100 : 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* CheckIcon */.nQ, {})
    });
    if (iconPosition === "right") {
        rightIcon = icon;
    } else {
        leftIcon = icon;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        bg: "white",
        borderColor: "gray.200",
        borderWidth: "1px",
        isActive: isActive,
        _active: {
            bg: "blue.50",
            borderColor: "blue.500"
        },
        _hover: {
            borderColor: "blue.500"
        },
        w: {
            base: "100%",
            md: "auto"
        },
        height: "auto",
        p: "1em",
        leftIcon: leftIcon,
        rightIcon: rightIcon
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
            pr: "1em",
            w: "100%",
            align: "flex-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                    fontSize: "md",
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_PriceLabel, {
                    price: price,
                    unit: unit
                })
            ]
        })
    }));
};


;// CONCATENATED MODULE: ./containers/Intake/form/RadioButtonField.tsx






var RadioButtonField = function(_param) {
    var name = _param.name, value = _param.value, label = _param.label, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "value",
        "label"
    ]);
    var field = (0,react_final_form_es/* useField */.U$)(name);
    var selected = field.input.value === value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        onClick: function() {
            return field.input.onChange(value);
        },
        isActive: selected
    }, rest), {
        children: label
    }));
};
/* harmony default export */ var form_RadioButtonField = (RadioButtonField);

;// CONCATENATED MODULE: ./containers/Intake/form/MutiselectButtonField.tsx







var updateFieldValue = function(fieldValue, value) {
    if (!value) return fieldValue;
    if (!fieldValue) return [
        value
    ];
    if (fieldValue.includes(value)) return fieldValue.filter(function(v) {
        return v !== value;
    });
    return (0,_to_consumable_array/* default */.Z)(fieldValue).concat([
        value
    ]);
};
var MultiselectField = function(_param) {
    var name = _param.name, value = _param.value, label = _param.label, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "value",
        "label"
    ]);
    var field = (0,react_final_form_es/* useField */.U$)(name);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        onClick: function() {
            return field.input.onChange(updateFieldValue(field.input.value, value));
        },
        isActive: field.input.value.includes(value)
    }, rest), {
        children: label
    }));
};
/* harmony default export */ var MutiselectButtonField = (MultiselectField);

;// CONCATENATED MODULE: ./containers/Intake/plan/FormBuilder.tsx



var FormBuilder = function(param) {
    var addons = param.addons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* VStack */.gC, {
        align: "stretch",
        gap: "2em",
        width: "100%",
        children: addons === null || addons === void 0 ? void 0 : addons.map(function(addon) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Addon, {
                addon: addon
            }, addon.id);
        })
    });
};
var controlTable = {
    multiselect: MultiSelect
};
function MultiSelect(param) {
    var addon = param.addon;
    // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
        direction: "row",
        gap: "0.5em",
        width: "100%",
        wrap: "wrap",
        children: addon.options.map(function(o) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MutiselectButtonField, {
                name: "addons.".concat(addon.id),
                value: o.id,
                label: o.label,
                price: o.price,
                unit: o.unit,
                iconPosition: "right"
            }, o.id);
        })
    });
}
var Addon = function(param) {
    var addon = param.addon;
    // @ts-ignore
    var Control = controlTable[addon.type];
    if (!Control) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
        align: "start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                size: "md",
                children: addon.label
            }),
            addon.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                children: addon.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Spacer */.LZ, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Control, {
                addon: addon
            })
        ]
    });
};
/* harmony default export */ var plan_FormBuilder = (FormBuilder);

;// CONCATENATED MODULE: ./containers/Intake/plan/Summary.tsx
// @ts-nocheck





var getInitialCoupons = function(config) {
    if (!config.coupons) return [];
    if (Array.isArray(config.coupons)) return config.coupons;
    try {
        if (typeof config.coupons === "function") return config.coupons();
    } catch (error) {
        console.error("Error getting initial coupons", {
            cause: error
        });
    }
    return [];
};
var Summary = function(param) {
    var config = param.config;
    var formState = (0,react_final_form_es/* useFormState */.cl)();
    var plan = config.plan.countries[formState.values.address.country];
    var planPeriod = plan.periods.find(function(p) {
        return p.id === formState.values.plan;
    });
    var addons = services_getAddonList(config, formState.values);
    var coupons = getInitialCoupons(config);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        direction: "column",
        gap: "1em",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                size: "md",
                children: "Summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.hr */.m$.hr, {
                    borderColor: "gray.300"
                }),
                align: "stretch",
                gap: "1em",
                my: "2em",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    planPeriod && /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryItem, {
                        label: plan.label,
                        unit: planPeriod.unit,
                        price: planPeriod.price
                    }),
                    coupons.length ? coupons.map(function(code) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponItem, {
                            code: code
                        }, code);
                    }) : null,
                    addons.map(function(addon) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryItem, {
                            label: addon.label,
                            price: addon.price,
                            unit: addon.unit
                        }, addon.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sum, {
                addons: addons,
                plan: planPeriod
            })
        ]
    });
};
var CouponItem = function(param) {
    var code = param.code;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "row",
                gap: "1em",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        size: "sm",
                        w: "100%",
                        children: "Coupon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        as: "code",
                        children: code
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                size: "small",
                color: "gray.500",
                children: "Applied at checkout"
            })
        ]
    });
};
var SummaryItem = function(param) {
    var label = param.label, price = param.price, unit = param.unit;
    var formattedPrice = services_formatPrice(price);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        direction: "row",
        gap: "1em",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                w: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        size: "sm",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "gray.500",
                        children: unit
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                as: "b",
                children: formattedPrice
            })
        ]
    });
};
var Sum = function(param) {
    var addons = param.addons, plan = param.plan;
    var oneTimePrice = (plan === null || plan === void 0 ? void 0 : plan.price) || 0;
    addons.forEach(function(addon) {
        oneTimePrice += addon.price;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        direction: "row",
        gap: "1em",
        divider: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                w: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                    size: "sm",
                    children: "Due Today"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "column",
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        size: "sm",
                        children: services_formatPrice(oneTimePrice)
                    }),
                    plan && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "gray.500",
                        whiteSpace: "nowrap",
                        children: "Plus tax"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var plan_Summary = (Summary);

;// CONCATENATED MODULE: ./containers/Intake/plan/PlanFormBuilder.tsx
// @ts-nocheck








var PlanFormBuilder = function(param) {
    var config = param.config, children = param.children;
    var form = (0,react_final_form_es/* useForm */.cI)();
    var formState = (0,react_final_form_es/* useFormState */.cl)();
    var country = formState.values.address.country;
    var plan = config.plan.countries[country];
    var selectedPeriod = plan.periods.find(function(p) {
        return p.id === formState.values.plan;
    });
    (0,react.useEffect)(function() {
        if (selectedPeriod) return;
        form.change("plan", plan.periods[0].id);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        direction: [
            "column",
            ,
            "row"
        ],
        align: "stretch",
        gap: "2em",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "column",
                gap: "3em",
                align: "stretch",
                width: [
                    "100%",
                    ,
                    "66%"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        alignSelf: "flex-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                            direction: "row",
                            gap: "1em",
                            wrap: "wrap",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                    size: "md",
                                    children: "Billing"
                                }),
                                plan.periods.map(function(p) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(form_RadioButtonField, {
                                        size: "xs",
                                        name: "plan",
                                        value: p.id,
                                        label: p.label
                                    }, p.id);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                        direction: "row",
                        gap: "1em",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                                flexGrow: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                        size: "md",
                                        children: plan.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        children: plan.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_PriceLabel, {
                                price: selectedPeriod === null || selectedPeriod === void 0 ? void 0 : selectedPeriod.price,
                                unit: selectedPeriod === null || selectedPeriod === void 0 ? void 0 : selectedPeriod.unit
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(plan_FormBuilder, {
                        addons: selectedPeriod === null || selectedPeriod === void 0 ? void 0 : selectedPeriod.addons
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "column",
                w: "100%",
                flex: "1",
                position: "relative",
                bg: "gray.50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.div */.m$.div, {
                        display: [
                            "none",
                            ,
                            "block"
                        ],
                        bg: "gray.50",
                        position: "fixed",
                        h: "9999px",
                        w: "100%",
                        top: "0",
                        zIndex: -1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        p: "2em",
                        w: "100%",
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(plan_Summary, {
                            config: config
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var plan_PlanFormBuilder = (PlanFormBuilder);

;// CONCATENATED MODULE: ./containers/Intake/plan/PricePlanView.tsx





var PricePlanView = function(param) {
    var plans = param.plans;
    var predicate = function(a, b) {
        return a === b;
    };
    var options = plans;
    var field = (0,react_final_form_es/* useField */.U$)("plan");
    var plan = field.input.value;
    var errors = {
        plan: field.meta.error
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        fontSize: "2xl",
                        mb: 6,
                        children: "Price Plan"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Wrap */.Eq, {
                    display: "block",
                    spacing: 3,
                    children: options.map(function(o, i) {
                        var isSelected = predicate(plan, o.value) || !plan && i === 0;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                            isActive: isSelected,
                            onClick: function() {
                                return field.input.onChange(o.value);
                            },
                            children: o.label
                        }, o.value);
                    })
                }),
                errors.plan && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    color: "red.300",
                    fontSize: "sm",
                    mt: 2,
                    px: 4,
                    children: "Please select a price plan."
                })
            ]
        })
    });
};
/* harmony default export */ var plan_PricePlanView = (PricePlanView);

;// CONCATENATED MODULE: ./containers/Intake/internal/BusinessPlanSection.tsx






var BusinessPlanSection = function(param) {
    var config = param.config, onBack = param.onBack;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_BackButton, {
                onClick: onBack,
                children: "Back"
            }),
            config.plans ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(plan_PricePlanView, {
                        plans: config.plans
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_MainButton, {
                        type: "submit",
                        children: "Continue"
                    })
                ]
            }) : null,
            config.plan ? /*#__PURE__*/ (0,jsx_runtime.jsx)(plan_PlanFormBuilder, {
                config: config,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_MainButton, {
                    type: "submit",
                    children: "Continue"
                })
            }) : null
        ]
    });
};
/* harmony default export */ var internal_BusinessPlanSection = (BusinessPlanSection);

;// CONCATENATED MODULE: ./containers/Intake/internal/BusinessView.tsx
















var BusinessView = function(param) {
    var onComplete = param.onComplete, config = param.config;
    useTrack(INTAKE_VIEWED);
    var views = config.plans && config.plans.length === 1 ? [
        "business",
        "details"
    ] : [
        "business",
        "plan",
        "details"
    ];
    var lastPage = views.length - 1;
    var ref = (0,_sliced_to_array/* default */.Z)(hooks_usePage(0, lastPage), 3), page = ref[0], next = ref[1], decrement = ref[2];
    var initialValues = (0,react.useMemo)(function() {
        var ref;
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialState.form), {
            partner: config.partner,
            plan: (ref = config.plans) === null || ref === void 0 ? void 0 : ref[0].value,
            id: config.partner.code,
            token: "",
            address: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialState.form.address), {
                country: config.countries[0]
            }),
            questions: config.questions
        });
    }, []);
    // eslint-disable-next-line consistent-return
    var onSubmit = function(form) {
        if (page < lastPage) {
            return next();
        }
        console.log("submit form", form);
        var normalizedState = Intake_normalizeFormState(form, config);
        console.log("normalizedState", normalizedState);
        onComplete(normalizedState);
    };
    // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
            onSubmit: onSubmit,
            initialValues: initialValues,
            mutators: {
                setFieldTouched: form_setFieldTouched
            },
            children: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    onSubmit: props.handleSubmit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                        direction: "column",
                        spacing: 8,
                        w: "100%",
                        children: [
                            props.submitFailed && props.hasValidationErrors && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_alert_esm/* Alert */.bZ, {
                                status: "error",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_alert_esm/* AlertIcon */.zM, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_alert_esm/* AlertDescription */.X, {
                                        children: "Please check the form for errors and try again."
                                    })
                                ]
                            }),
                            views[page] === "business" && // @ts-ignore
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(internal_BusinessMainSection, {
                                config: config
                            }),
                            views[page] === "plan" && /*#__PURE__*/ (0,jsx_runtime.jsx)(internal_BusinessPlanSection, {
                                config: config,
                                onBack: decrement
                            }),
                            views[page] === "details" && /*#__PURE__*/ (0,jsx_runtime.jsx)(internal_BusinessDetailsSection, {
                                config: config,
                                onBack: decrement
                            })
                        ]
                    })
                });
            }
        })
    });
};
/* harmony default export */ var internal_BusinessView = (BusinessView);

;// CONCATENATED MODULE: ./utils/getChargebeeSiteId.ts
var getChargebeeSiteId = function() {
    return  false ? 0 : "getinthelooplocal";
};
/* harmony default export */ var utils_getChargebeeSiteId = (getChargebeeSiteId);

;// CONCATENATED MODULE: ./hooks/chargebee/useChargebee.js
/* eslint-disable-next-line no-redeclare */ /* global window, document */ 

var initalizeChargebee = function(callback) {
    if (window.Chargebee) {
        return callback(utils_getChargebeeSiteId(), "live_eyhdTC1iPS3TIzWXB9Bhavv9MwUAB9vT");
    }
    var script = document.createElement("script");
    script.setAttribute("src", "https://js.chargebee.com/v2/chargebee.js");
    script.setAttribute("data-cb-site", utils_getChargebeeSiteId());
    script.onload = function() {
        callback(utils_getChargebeeSiteId(), "live_eyhdTC1iPS3TIzWXB9Bhavv9MwUAB9vT");
    };
    document.body.appendChild(script);
};
var useChargebee = function() {
    var ref = (0,react.useState)(null), cbInstance = ref[0], setCbInstance = ref[1];
    (0,react.useEffect)(function() {
        initalizeChargebee(function(site, publishableKey) {
            window.Chargebee.tearDown();
            setCbInstance(window.Chargebee.init({
                site: site,
                publishableKey: publishableKey,
                iframeOnly: true,
                isItemsModel: true // needed for Chargebee Catalog v2.0
            }));
        });
    }, []);
    return cbInstance;
};
/* harmony default export */ var chargebee_useChargebee = (useChargebee);

;// CONCATENATED MODULE: ./hooks/chargebee/useChargebeeCheckoutHostedPage.ts



var useChargebeeCheckoutHostedPage = function(business) {
    var ref = (0,react.useState)(), error = ref[0], setError = ref[1];
    var chargebeeInstance = chargebee_useChargebee();
    var openCheckout = (0,react.useMemo)(function() {
        return function() {
            var chargebeeCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            if (!chargebeeInstance) return null;
            // @ts-ignore
            chargebeeInstance.closeAll(); // Ensure we don't try to open multiple at the same time
            setError(undefined);
            // @ts-ignore Look, just trust me, ok?
            return chargebeeInstance.openCheckout((0,src_object_spread/* default */.Z)({
                hostedPage: function() {
                    return Promise.resolve(business.hostedPageUrl);
                },
                layout: "in_app",
                error: setError
            }, chargebeeCallbacks));
        };
    }, [
        business,
        chargebeeInstance
    ]);
    return [
        openCheckout,
        chargebeeInstance,
        error
    ];
};
/* harmony default export */ var chargebee_useChargebeeCheckoutHostedPage = (useChargebeeCheckoutHostedPage);

;// CONCATENATED MODULE: ./containers/Intake/ChargebeeView.tsx







var ChargebeeForm = function(param) {
    var business = param.business, onComplete = param.onComplete;
    (0,react.useEffect)(function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    useTrack(INTAKE_PAYMENT_STARTED);
    var ref = (0,_sliced_to_array/* default */.Z)(chargebee_useChargebeeCheckoutHostedPage(business), 3), openCheckoutWidget = ref[0], chargebeeInstance = ref[1], checkoutError = ref[2];
    var openCheckout = (0,react.useMemo)(function() {
        return function() {
            if (!openCheckoutWidget) return null;
            return openCheckoutWidget({
                step: function(value) {
                    if (value === "thankyou_screen") onComplete();
                }
            });
        };
    }, [
        openCheckoutWidget
    ]);
    (0,react.useEffect)(function() {
        if (!chargebeeInstance) return;
        openCheckout();
    }, [
        chargebeeInstance,
        openCheckoutWidget
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            checkoutError && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_alert_esm/* Alert */.bZ, {
                status: "error",
                flexDirection: "row",
                mb: "1em",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_alert_esm/* AlertIcon */.zM, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                        flexDirection: "column",
                        gap: "1em",
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_alert_esm/* AlertTitle */.Cd, {
                                children: "Something went wrong"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_alert_esm/* AlertDescription */.X, {
                                children: [
                                    "Try again or contact ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:support@getintheloop.ca",
                                        children: "support@getintheloop.ca"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                onClick: openCheckout,
                size: "lg",
                colorScheme: "blue",
                children: "Open Checkout"
            })
        ]
    });
};
/* harmony default export */ var ChargebeeView = (ChargebeeForm);

;// CONCATENATED MODULE: ./containers/Intake/internal/SocialCompleteView.tsx





var CompleteForm = function() {
    useTrack(INTAKE_COMPLETE);
    (0,react.useEffect)(function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    // Using `useEffect` so we don't try to access `window` during SSR
    var ref = (0,react.useState)(false), isLinkingComplete = ref[0], setIsLinkingComplete = ref[1];
    (0,react.useEffect)(function() {
        setIsLinkingComplete(new URL(window.location.href).searchParams.get("step") === "complete");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.img */.m$.img, {
                src: "https://www.facebook.com/tr?id=8958680527559036&ev=CompleteRegistration",
                height: "1",
                width: "1",
                style: {
                    display: "none"
                }
            }),
            isLinkingComplete ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        fontSize: "2xl",
                        mb: 6,
                        children: "Social AI Setup Complete!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "Your GetintheLoop Customer Success Manager will reach out shortly to finalize your content strategy."
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        fontSize: "2xl",
                        mb: 6,
                        children: "Social AI Setup Skipped"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "Your GetintheLoop Customer Success Manager will reach out shortly to help finalize your Social AI onboarding."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SocialCompleteView = (CompleteForm);

// EXTERNAL MODULE: ../../node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js
var chakra_ui_hooks_esm = __webpack_require__(4756);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/modal/dist/chakra-ui-modal.esm.js + 58 modules
var chakra_ui_modal_esm = __webpack_require__(7695);
// EXTERNAL MODULE: ./services/intake/rollbar.ts
var rollbar = __webpack_require__(8393);
;// CONCATENATED MODULE: ./containers/Intake/ErrorAlert.tsx



var ErrorAlert = function(param) {
    var error = param.error;
    if (!error) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_alert_esm/* Alert */.bZ, {
        status: "error",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_alert_esm/* AlertIcon */.zM, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_alert_esm/* AlertTitle */.Cd, {
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_alert_esm/* AlertDescription */.X, {
                children: [
                    "Please try again or contact ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:support@getintheloop.ca",
                        children: "support@getintheloop.ca"
                    }),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var Intake_ErrorAlert = (ErrorAlert);

// EXTERNAL MODULE: ../../node_modules/@chakra-ui/checkbox/dist/chakra-ui-checkbox.esm.js
var chakra_ui_checkbox_esm = __webpack_require__(9338);
;// CONCATENATED MODULE: ./containers/Intake/LinkingModal.tsx



var LinkingModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var ref = (0,react.useState)(false), authorized = ref[0], setAuthorized = ref[1];
    var ref1 = (0,react.useState)(false), read = ref1[0], setRead = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_modal_esm/* Modal */.u_, {
        isOpen: isOpen,
        onClose: onClose,
        size: "4xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_modal_esm/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* ModalHeader */.xB, {
                        children: "Accept Terms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* ModalBody */.fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                            direction: "column",
                            gap: "1em",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "Social AI requires you to have full control of the Facebook Page or Instagram account you are connecting to."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "Make sure you have the correct permissions and that you're signed in to Facebook before proceeding."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_checkbox_esm/* Checkbox */.XZ, {
                                    isChecked: authorized,
                                    onChange: function(e) {
                                        return setAuthorized(e.target.checked);
                                    },
                                    alignItems: "baseline",
                                    children: "I understand that GetintheLoop's Social AI will automatically post to the social media accounts I have connected. I authorized GetintheLoop to post to my connected social media accounts on my behalf."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_checkbox_esm/* Checkbox */.XZ, {
                                    isChecked: read,
                                    onChange: function(e) {
                                        return setRead(e.target.checked);
                                    },
                                    alignItems: "baseline",
                                    children: "I have read and agree to GetintheLoop's Social AI Terms & Conditions."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* ModalFooter */.mz, {
                        justifyContent: "flex-start",
                        pt: "2em",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                            onClick: function() {
                                return onClose(true);
                            },
                            colorScheme: "blue",
                            disabled: !authorized || !read,
                            children: "Continue"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Intake_LinkingModal = (LinkingModal);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2838);
// EXTERNAL MODULE: ../../node_modules/node-fetch/browser.js
var browser = __webpack_require__(4911);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./services/intake/createProfile.ts



var createProfile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(business) {
        var path, headers, body, response, json, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    path = "".concat("https://admin-api.loopmediagroup.com", "/businesses/social/profile/fromReservedIdToken?fields=name,timezone,enabled,created");
                    headers = new (browser_default()).Headers({
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "X-Api-Version": "1.0.10",
                        "X-Sdk-Name": "partner-intake",
                        "X-Sdk-Version": "4.91.1"
                    });
                    body = {
                        name: business.name,
                        timezone: "America/Vancouver",
                        token: business.token
                    };
                    return [
                        4,
                        browser_default()(path, {
                            method: "POST",
                            headers: headers,
                            body: JSON.stringify(body)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    json = _state.sent();
                    if (!response.ok) {
                        e = new Error("".concat(response.status, " ").concat(response.statusText));
                        // @ts-ignore WRONG!
                        e.response = response;
                        // @ts-ignore I think you'll find `cause` _does_ exist on Error
                        e.cause = json;
                        throw e;
                    }
                    return [
                        2,
                        json.payload
                    ];
            }
        });
    });
    return function createProfile(business) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var intake_createProfile = (createProfile);

;// CONCATENATED MODULE: ./services/intake/linkSocials.ts




var linkSocials = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(business, redirectUrl) {
        var path, headers, body, response, json, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    path = "".concat("https://admin-api.loopmediagroup.com", "/businesses/social/profile/ayrshare/fromReservedIdToken?fields=url");
                    headers = new (browser_default()).Headers({
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "X-Api-Version": "1.0.10",
                        "X-Sdk-Name": "partner-intake",
                        "X-Sdk-Version": "4.91.1"
                    });
                    body = {
                        token: business.token,
                        redirect: redirectUrl
                    };
                    return [
                        4,
                        browser_default()(path, {
                            method: "POST",
                            headers: headers,
                            body: JSON.stringify(body)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    json = _state.sent();
                    if (!response.ok) {
                        e = new Error("".concat(response.status, " ").concat(response.statusText));
                        // @ts-ignore WRONG!
                        e.response = response;
                        // @ts-ignore I think you'll find `cause` _does_ exist on Error
                        e.cause = json;
                        rollbar/* default.error */.Z.error(e);
                        throw e;
                    }
                    return [
                        2,
                        json.payload
                    ];
            }
        });
    });
    return function linkSocials(business, redirectUrl) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var intake_linkSocials = (linkSocials);

;// CONCATENATED MODULE: ./containers/Intake/usePrepareSocialLinking.ts






var MAX_POLL_DURATION = 10000;
var pollLinkSocials = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(business, redirectUrl) {
        var duration, now, err, newDuration;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    duration = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 0;
                    if (duration > MAX_POLL_DURATION) throw new Error("Unable to get Social Linking URL in a reasonable time.");
                    now = Date.now();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        intake_linkSocials(business, redirectUrl)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    err = _state.sent();
                    if (!((0,_instanceof/* default */.Z)(err, Error) && err.response && err.response.status === 400)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        new Promise(function(res) {
                            return setTimeout(res, 1000);
                        })
                    ];
                case 4:
                    _state.sent();
                    newDuration = duration + (Date.now() - now);
                    return [
                        2,
                        pollLinkSocials(business, redirectUrl, newDuration)
                    ];
                case 5:
                    throw err;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function pollLinkSocials(business, redirectUrl) {
        return _ref.apply(this, arguments);
    };
}();
var usePrepareSocialLinking = function() {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var prepareSocialLinking = (0,react.useCallback)(function() {
        var _ref = // eslint-disable-next-line consistent-return
        (0,_async_to_generator/* default */.Z)(function(business, redirectUrl) {
            var response, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setError(undefined);
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            intake_createProfile(business)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            pollLinkSocials(business, redirectUrl)
                        ];
                    case 3:
                        response = _state.sent();
                        return [
                            2,
                            response.url
                        ];
                    case 4:
                        err = _state.sent();
                        setError(err);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(business, redirectUrl) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return [
        prepareSocialLinking,
        loading,
        error
    ];
};
/* harmony default export */ var Intake_usePrepareSocialLinking = (usePrepareSocialLinking);

;// CONCATENATED MODULE: ./containers/Intake/ExternalLink.tsx





var ExternalLink = function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.a */.m$.a, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        target: "_blank",
        textDecoration: "underline",
        color: "blue.600"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var Intake_ExternalLink = (ExternalLink);

;// CONCATENATED MODULE: ./containers/Intake/AyrshareView.tsx













var AyrshareView = function(param) {
    var business = param.business, onComplete = param.onComplete;
    var isSmallScreen = (0,chakra_ui_media_query_esm/* useBreakpointValue */.Sx)({
        base: true,
        sm: false
    });
    var ref = (0,chakra_ui_hooks_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var ref1 = (0,_sliced_to_array/* default */.Z)(Intake_usePrepareSocialLinking(), 3), prepareSocialLinking = ref1[0], loading = ref1[1], error = ref1[2];
    var handleClose = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(accepted) {
            var ref, redirect, ayrshareUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onClose();
                        if (!accepted) return [
                            2
                        ];
                        (ref = analytics_analytics()) === null || ref === void 0 ? void 0 : ref.track(INTAKE_ACCOUNT_LINKING_STARTED);
                        redirect = new URL(window.location.href);
                        // Set new "back" url...
                        redirect.searchParams.set("step", "complete");
                        window.history.pushState({}, "", redirect.href);
                        return [
                            4,
                            prepareSocialLinking(business, redirect.href)
                        ];
                    case 1:
                        ayrshareUrl = _state.sent();
                        if (!ayrshareUrl) return [
                            2
                        ];
                        rollbar/* default.info */.Z.info("Redirect To Ayrshare", ayrshareUrl, business);
                        window.location.href = ayrshareUrl;
                        return [
                            2
                        ];
                }
            });
        });
        return function(accepted) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onClose
    ]);
    // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        maxW: "4xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                direction: "column",
                gap: "1em",
                w: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        fontSize: "2xl",
                        mb: 6,
                        children: "Payment Method Successful!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        fontSize: "2xl",
                        mb: 6,
                        children: "Connect Your Social Accounts To Complete Setup"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "Link one or both of your social accounts so we can start posting on your behalf."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        children: "What you need:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* UnorderedList */.QI, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                                children: "Login credentials to your social accounts"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                                children: '"Full Control" access over the Facebook Page or Instagram Account you\'re connecting'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                        children: [
                            'If you do not have this access today, select "I\'ll connect later".',
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                children: [
                                    "If you experience any issues during the linking process, exit the webpage and notify us at",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_ExternalLink, {
                                        href: "mailto:support@getintheloop.ca",
                                        children: "support@getintheloop.ca"
                                    }),
                                    " ",
                                    "so your customer success manager can help."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                        gap: "1em",
                        pt: "1em",
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                                onClick: onOpen,
                                w: isSmallScreen ? "100%" : undefined,
                                colorScheme: "blue",
                                children: "Link Social Accounts"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                                onClick: onComplete,
                                w: isSmallScreen ? "100%" : undefined,
                                children: "I'll Connect Later"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "sm",
                        color: "gray.600",
                        children: [
                            "See ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_ExternalLink, {
                                href: "https://support.getintheloop.ca/knowledge/social-ai",
                                children: "full details "
                            }),
                            " of requirements for Facebook and Instagram accounts."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_ErrorAlert, {
                        error: error
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_LinkingModal, {
                isOpen: isOpen,
                onClose: handleClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_modal_esm/* Modal */.u_, {
                isOpen: loading,
                isCentered: true,
                size: "xl",
                scrollBehavior: "inside",
                variant: "ghost",
                onClose: function() {},
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_modal_esm/* ModalContent */.hz, {
                        alignItems: "center",
                        color: "white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_spinner_esm/* Spinner */.$, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                textAlign: "center",
                                children: "We're preparing to link your socials, this should only take a minute."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                textAlign: "center",
                                children: "Please do not refresh..."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Intake_AyrshareView = (AyrshareView);

;// CONCATENATED MODULE: ./containers/Intake/extractErrorDetails.ts
// Field-specific errors are frequently of the form:
// "fieldName" with value "invalid_value" fails to match..."
var ERROR_FIELD_REGEX = /^"(\S+)"/;
var extractErrorDetails = function(error) {
    var ref, ref1, ref2;
    if (!error) return null;
    // Error cause is found in a couple of different places...
    if (!error.cause) return "ref ".concat(error === null || error === void 0 ? void 0 : error.message);
    var errorMessage = ((ref = error.cause.context) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.details) || ((ref2 = error.cause.context) === null || ref2 === void 0 ? void 0 : ref2.details);
    if (errorMessage) {
        var match = errorMessage.match(ERROR_FIELD_REGEX);
        if (!match) return errorMessage;
        if (match[1]) return 'There was a problem with "'.concat(match[1], '"');
    }
    return errorMessage;
};
/* harmony default export */ var Intake_extractErrorDetails = (extractErrorDetails);

;// CONCATENATED MODULE: ./containers/Intake/useChargebeeCompleteCallback.ts



// import submitIntake from '../../services/intake/submitIntake';
var useChargebeeCompleteCallback = function(business, callback) {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var onChargebeeComplete = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            setError(null);
            setLoading(true);
            if (business) {
                try {
                    // await submitIntake(business);
                    callback();
                } catch (err) {
                    setError(err);
                }
                setLoading(false);
            }
            return [
                2
            ];
        });
    }), [
        business
    ]);
    return [
        onChargebeeComplete,
        loading,
        error
    ];
};
/* harmony default export */ var Intake_useChargebeeCompleteCallback = (useChargebeeCompleteCallback);

;// CONCATENATED MODULE: ./services/intake/fetchChargebeeHostedPage.ts




var buildCustomer = function(business) {
    return {
        company: business.name,
        id: business.id,
        cf_business_id: business.id,
        // Ensure we don't send `""` for custom fields
        cf_franchise_area: business.partner.franchiseCode || undefined,
        cf_affiliate_customer_id: business.partner.affiliateCustomerId || undefined,
        first_name: business.contact.firstName,
        last_name: business.contact.lastName || undefined,
        email: business.contact.email,
        // Ensure we don't send `""` for `phone`
        phone: business.contact.phone && business.contact.phone.replace(/\D/g, "") || undefined
    };
};
var buildBillingAddress = function(business) {
    return {
        first_name: business.contact.firstName,
        last_name: business.contact.lastName || undefined,
        company: business.name,
        line1: [
            business.address.unit,
            business.address.streetNumber,
            business.address.streetName
        ].filter(Boolean).join(" "),
        city: business.address.city,
        state_code: business.address.stateCode,
        zip: String(business.address.postalCode).toUpperCase(),
        country: business.address.country
    };
};
var fetchChargebeeHostedPage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var business, partnerCode, coupons, ref, path, headers, body, response, json, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    business = param.business, partnerCode = param.partnerCode, coupons = param.coupons;
                    path = "".concat("https://admin-api.loopmediagroup.com", "/businesses/chargebee/checkout/fromReservedIdToken?fields=url");
                    headers = new (browser_default()).Headers({
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "X-Api-Version": "1.0.10",
                        "X-Sdk-Name": "partner-intake",
                        "X-Sdk-Version": "4.91.1"
                    });
                    body = {
                        itemPriceId: business.plan,
                        code: partnerCode,
                        customer: buildCustomer(business),
                        billingAddress: buildBillingAddress(business),
                        coupons: coupons,
                        token: business.token,
                        meta: business,
                        itemPriceIds: (ref = business.addons) === null || ref === void 0 ? void 0 : ref.map(function(addon) {
                            return {
                                item_price_id: addon.id
                            };
                        })
                    };
                    return [
                        4,
                        browser_default()(path, {
                            method: "POST",
                            headers: headers,
                            body: JSON.stringify(body)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    json = _state.sent();
                    if (!response.ok) {
                        e = new Error("".concat(response.status, " ").concat(response.statusText));
                        // @ts-ignore WRONG!
                        e.response = response;
                        // @ts-ignore I think you'll find `cause` _does_ exist on Error
                        e.cause = json;
                        rollbar/* default.error */.Z.error(e);
                        throw e;
                    }
                    return [
                        2,
                        json.payload
                    ];
            }
        });
    });
    return function fetchChargebeeHostedPage(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var intake_fetchChargebeeHostedPage = (fetchChargebeeHostedPage);

;// CONCATENATED MODULE: ./services/intake/reserveBusiness.js




var reserveBusiness = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(business) {
        var path, body, response, e, json;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    path = "/api/reserveBusinessProxy";
                    body = business;
                    return [
                        4,
                        browser_default()(path, {
                            method: "POST",
                            body: JSON.stringify(body)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        e = new Error("".concat(response.status, " ").concat(response.statusText));
                        e.response = response;
                        rollbar/* default.error */.Z.error(e);
                        throw e;
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    json = _state.sent();
                    return [
                        2,
                        {
                            id: json.payload.id,
                            token: json.payload.token
                        }
                    ];
            }
        });
    });
    return function reserveBusiness(business) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var intake_reserveBusiness = (reserveBusiness);

;// CONCATENATED MODULE: ./containers/Intake/getCoupons.ts

var getCoupons = function(business, config) {
    if (!config.coupons) return [];
    if (Array.isArray(config.coupons)) return config.coupons;
    if ((0,_instanceof/* default */.Z)(config.coupons, Function)) return config.coupons(business);
    throw new Error("Invalid config value for coupons");
};
/* harmony default export */ var Intake_getCoupons = (getCoupons);

;// CONCATENATED MODULE: ./containers/Intake/useBusinessCompleteCallback.ts









var useBusinessCompleteCallback = function(config, callback) {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var onBusinessComplete = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, id, token, newBusiness, hostedPageUrl, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setError(null);
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            intake_reserveBusiness(data)
                        ];
                    case 2:
                        ref = _state.sent(), id = ref.id, token = ref.token;
                        newBusiness = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
                            id: id,
                            token: token
                        });
                        return [
                            4,
                            intake_fetchChargebeeHostedPage({
                                business: newBusiness,
                                partnerCode: config.partner.channelPartnerCode,
                                coupons: Intake_getCoupons(newBusiness, config)
                            })
                        ];
                    case 3:
                        hostedPageUrl = _state.sent();
                        newBusiness.hostedPageUrl = hostedPageUrl;
                        rollbar/* default.info */.Z.info("Partner Checkout Started", newBusiness);
                        callback(newBusiness);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        setError(err);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return [
        onBusinessComplete,
        loading,
        error
    ];
};
/* harmony default export */ var Intake_useBusinessCompleteCallback = (useBusinessCompleteCallback);

;// CONCATENATED MODULE: ./components/Intake/LoadingScreen.tsx


var LoadingScreen = function(param) {
    var isLoading = param.isLoading, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_modal_esm/* Modal */.u_, {
        isOpen: isLoading,
        isCentered: true,
        size: "xl",
        scrollBehavior: "inside",
        variant: "ghost",
        onClose: function() {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* ModalContent */.hz, {
                alignItems: "center",
                color: "white",
                children: children
            })
        ]
    });
};
/* harmony default export */ var Intake_LoadingScreen = (LoadingScreen);

;// CONCATENATED MODULE: ./containers/Intake/internal/IntakeViewModel.tsx



















var IntakeViewModel = function(param) {
    var config = param.config;
    var isCheckoutCompleteRef = (0,react.useRef)(false);
    var stepsCount = config.steps ? Object.keys(config.steps).length : 3;
    var ref = (0,_sliced_to_array/* default */.Z)(hooks_usePage(0, stepsCount), 4), page = ref[0], next = ref[1], jump = ref[3];
    usePage({
        title: config.partner.name
    });
    var ref1 = (0,react.useState)(), business = ref1[0], setBusiness = ref1[1];
    (0,react.useEffect)(function() {
        // If we've redirected from Social linking, jump to "Complete" step
        var isComplete = new URL(window.location.href).searchParams.get("step") === "complete";
        if (isComplete) {
            rollbar/* default.info */.Z.info("Redirect From Ayrshare", business);
            jump(stepsCount - 1);
        }
    }, []);
    (0,react.useEffect)(function() {
        return Intake_validateConfig(config);
    }, []);
    var ref2 = (0,_sliced_to_array/* default */.Z)(Intake_useBusinessCompleteCallback(config, function(newBusiness) {
        setBusiness(newBusiness);
        next();
    }), 3), onBusinessComplete = ref2[0], onBusinessCompleteLoading = ref2[1], onBusinessCompleteError = ref2[2];
    var ref3 = (0,_sliced_to_array/* default */.Z)(Intake_useChargebeeCompleteCallback(business, function() {
        var ref;
        // Somehow, the Chargebee widget is executing the callback twice
        if (isCheckoutCompleteRef.current) return;
        isCheckoutCompleteRef.current = true;
        (ref = analytics_analytics()) === null || ref === void 0 ? void 0 : ref.track(INTAKE_PAYMENT_COMPLETE);
        rollbar/* default.info */.Z.info("Partner Checkout Complete", business);
        next();
    }), 3), onChargebeeComplete = ref3[0], onChargebeeCompleteLoading = ref3[1], onChargebeeCompleteError = ref3[2];
    var loading = onBusinessCompleteLoading || onChargebeeCompleteLoading;
    var error = onBusinessCompleteError || onChargebeeCompleteError;
    var errorDetails = Intake_extractErrorDetails(error);
    var onAyrshareComplete = (0,react.useCallback)(function() {
        next();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                fontWeight: 800,
                children: config.pageTitle || "Business Partner Intake Form"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intake_LoadingScreen, {
                isLoading: loading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_spinner_esm/* Spinner */.$, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        textAlign: "center",
                        sx: {
                            textWrap: "balance"
                        },
                        children: "We're completing the partner upload, this should only take a minute."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        textAlign: "center",
                        children: "Please do not refresh..."
                    })
                ]
            }),
            page === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(internal_BusinessView, {
                config: config,
                onComplete: onBusinessComplete
            }),
            page === 1 && business && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChargebeeView, {
                business: business,
                onComplete: onChargebeeComplete
            }),
            page === 2 && business && /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_AyrshareView, {
                onComplete: onAyrshareComplete,
                business: business
            }),
            page >= 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCompleteView, {}),
            error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_alert_esm/* Alert */.bZ, {
                status: "error",
                flexDirection: "column",
                gap: "1em",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_alert_esm/* AlertIcon */.zM, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_alert_esm/* AlertTitle */.Cd, {
                        children: "Something went wrong"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_alert_esm/* AlertDescription */.X, {
                        children: [
                            "Please try again or contact ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intake_ExternalLink, {
                                href: "mailto:support@getintheloop.ca",
                                children: "support@getintheloop.ca"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_alert_esm/* AlertDescription */.X, {
                        children: errorDetails
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var internal_IntakeViewModel = (IntakeViewModel);


/***/ }),

/***/ 8266:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var defaultQuestions = {
    wantToFeature: {
        label: "What are the products, services or promotions that you want to feature on social?",
        // eslint-disable-next-line max-len
        placeholder: "List up to 10 products, services or promotions that you would like to post on social. IE Happy hour, Sales, new arrivals, long term offerings, customer favourites. The more, the better, this is the content base we will built your social posts off of."
    },
    stockPhotoApproval: {
        label: "We prioritize any photos you provide — Can we source additional photos if needed?",
        placeholder: "",
        options: [
            {
                value: "",
                label: "Choose"
            },
            {
                value: "Yes",
                label: "Yes"
            },
            {
                value: "No",
                label: "No"
            }, 
        ],
        required: true,
        type: "select"
    },
    brandColor: {
        label: "What is your primary brand colour?",
        placeholder: "",
        type: "color"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (defaultQuestions);


/***/ }),

/***/ 669:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    1: {
        label: "Business"
    },
    2: {
        label: "Billing"
    },
    3: {
        label: "Connect Accounts"
    },
    4: {
        label: "Complete",
        hidden: true
    }
});


/***/ })

}]);